import { generateReservationConfirmationCode } from '@curbnturf/helpers';
import { IMessageChannel, IUser } from '../interfaces';
import { Listing } from './listing';
import { Message } from './message';
import { Reservation } from './reservation';
import { User } from './user';

export class MessageChannel implements IMessageChannel {
  id?: number;
  user?: IUser;
  userId?: number;
  reservation?: Reservation;
  reservationId?: number;
  listing?: Listing;
  listingId?: number;
  timestamp?: number;
  messages?: Message[];
  deleted?: boolean;
  deletedDate?: number;

  constructor(data?: IMessageChannel) {
    if (data) {
      this.setData(data);
    }
  }

  setData(data: IMessageChannel): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key) && key !== 'messages') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }

    this.messages = data.messages ? data.messages.map((message) => new Message(message)) : [];
  }

  getOtherName(currentUser: User): string {
    if (this.user && this.listing && currentUser.id === this.user.id) {
      return User.getName(this.listing.user);
    }
    return User.getName(this.user);
  }

  getAboutName(): string {
    if (this.reservation) {
      return this.listing?.name || generateReservationConfirmationCode(this.reservation);
    }

    if (this.listing) {
      return `${this.listing.name}`;
    }

    return '';
  }
}
